import { STATIC_PATH } from "../../constants/config";
import { loadScript } from "../loadRazorpayScript";

const useRazorpay = () => {
    const initiateRazorpayPayment = async (res, callback) => {
        try {
            await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            const options = {
                key: res.key_id,
                currency: "INR",
                name: "Vmaker AI",
                image: `${STATIC_PATH}vmakerai_logo.svg`,
                amount: res.totalamount,
                description: res.plan_name,
                order_id: res.order_id,
                callback_url: res.callback_url,
                redirect: false,
                handler: async (response) => {
                    try {
                        callback?.(response, res.callback_url);
                    } catch (err) {
                        callback?.(false);
                    }
                },
                modal: {
                    escape: false,
                    ondismiss() {
                        callback?.(false);
                    },
                },
                prefill: {
                    name: res.name,
                    email: res.email,
                },
                notes: {
                    address: "1160 Battery Street Suite 100, San Francisco, CA 94111, USA.",
                },
                theme: {
                    color: "#61dafb",
                },
            };

            const rzp1 = new window.Razorpay(options);
            rzp1.open();

        } catch (error) {
            console.error("Razorpay script load error:", error);
            callback?.(false);
        }
    };

    return {
        initiateRazorpayPayment,
    };
};

export default useRazorpay;
